import React, { useEffect, useState } from "react";
import ConfirmDialog from "./ConfirmDialog";
import { registerDiscardPrompt } from "../utils/offlineSync";

// Mounted once near the app root; confirmDiscardPendingOfflineData() opens it from hooks and handlers outside React.
const DiscardOfflineChangesPrompt = () => {
  const [request, setRequest] = useState(null);

  useEffect(
    () => registerDiscardPrompt((info) => new Promise((resolve) => setRequest({ ...info, resolve }))),
    []
  );

  const close = (answer) => {
    request.resolve(answer);
    setRequest(null);
  };

  return (
    <ConfirmDialog
      open={Boolean(request)}
      title="Unsynced offline changes"
      message={
        request
          ? `You have ${request.pending} offline change(s) that have not been synced. They will be lost if you ${request.action}.`
          : ""
      }
      confirmLabel="Discard and continue"
      cancelLabel="Stay"
      danger
      onConfirm={() => close(true)}
      onCancel={() => close(false)}
    />
  );
};

export default DiscardOfflineChangesPrompt;
